import { GC_GET_SCENARIO_LIST, GC_GET_SCENARIO_BY_ID, GC_GET_SCENARIOS_FIRST_NODE_CONDIDATES } from '@/graphql/scenario'
import apollo from '@/apolloClient'

export default {
    namespaced: true,
    state: {
        list: [],
        items: {},
        firstNodeCandidates: [],
    },
    mutations: {
        SET_SCENARIO_LIST(state, scenarios) {
            state.list = (scenarios || [])
        },
        SET_SCENARIO(state, scenario) {
            if (!scenario || !scenario.id)
                return

            state.items[scenario.id] = scenario
        },
        SET_FIRST_NODE_CANDIDATES(state, firstNodeCandidates) {
            state.firstNodeCandidates = (firstNodeCandidates || [])
        },
    },
    actions: {
        async getList({ commit }) {
            const response = await apollo.query({ query: GC_GET_SCENARIO_LIST })

            commit('SET_SCENARIO_LIST', response.data.scenario)
        },
        async getByID({ commit }, id) {
            let response = await apollo.query({
                query: GC_GET_SCENARIO_BY_ID,
                variables: { id }
            })

            if (!response.data.scenario || response.data.scenario.length <= 0) {
                commit('SET_SCENARIO', null)
                return
            }

            commit('SET_SCENARIO', response.data.scenario[0])
        },
        async getFirstNodeCandidates({ commit }) {
            const response = await apollo.query({ query: GC_GET_SCENARIOS_FIRST_NODE_CONDIDATES })

            commit('SET_FIRST_NODE_CANDIDATES', response.data.node)
        },
    }
}